<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About The Author</h1>
<p>Christine Brown has worked as a journalist on national and regional newspapers and women’s magazines. Her first book, <em>Goodbye Patrick,</em> told the story of her five adopted children. Her second book, <em>The Visits,</em> told the story of her visits she made, over the years, to men in one particular prison. She read English literature at St Hilda’s College, Oxford, and went on to do her PhD at Reading University. She was born in Edinburgh and now lives in Buckinghamshire.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?86cb916e